/**
 * 提供與後台連結的 api 接口
 */
import axios from "axios/index";
import qs from 'qs';


//TODO: Consider setting path config
export default {

    /**
     * Get Main and sub category
     * @returns {AxiosPromise<any>}
     */
    getSpecialMainCate()
    {
        return axios.get(`/api/special_main_category/get_main_cate_by_website?subject=${ window.urlData.subjectCompo}`);
    },
    getSpecialMainCateById(id) {
        return axios.get(`/api/special_main_category/get_sub_cate_by_maincate?maincate=${id}`)
    },
    /**
     * Get the banner in home page
     * @returns {AxiosPromise<any>}
     */
    getBanner()
    {
        return axios.get(`/api/home/get_banner?subject=${ window.urlData.subjectCompo}`);
        //return axios.get(`js/testdata/banner.json`);
    },

    /**
     * Get sub category listing
     * @param subCsateId
     * @param status
     *
     * @returns {AxiosPromise<any>}
     */
    getSubCateListById(subCsateId, status = "Final")
    {


        return axios.post('/api/special_subcate/nswfrontend_get_by_id', {
            sub_cate_id: subCsateId,
            status: status
        });

    },

    /**
     * Get the data for My Download
     *
     * @return {Promise<any>}
     */
    getDownloadData(skip= 0, limit = 5)
    {
        return new Promise((resolve, reject)=> {
            axios.post('/api/my_download/get_by_id', {
                    "website": `${ window.urlData.subjectCompo}`,
                    "skip": skip,
                    "limit": limit
                }
            ).then(response =>{
                //TODO: handle more practical cases if necessary. Now just simply check status 200
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject(response)
                }
            })
        });
    },
    /**
     * from MyDownload.vue
     *
     * remove resource by array key
     *
     * @param key
     * @returns {AxiosPromise<any>}
     */
    removeResource(key)
    {
        return axios.post('/api/my_download/remove_resource', {
            "resource_key": key,
            "website": `${ window.urlData.subjectCompo}`
        });
    },
    /**
     * from MyDownload.vue
     *
     * remove all selected resources
     *
     * @returns {AxiosPromise<any>}
     */
    removeAllResource()
    {
        return axios.post('/api/my_download/remove_all_resource', {
            "website": `${ window.urlData.subjectCompo}`
        });
    },

    /**
     * from MyDownload.vue
     *
     * save and pack download zip file
     *
     * @returns {AxiosPromise<any>}
     */
    saveMyDownloadRecord()
    {
        return axios.post('/api/my_download/save_my_download_record', {
            "website": `${ window.urlData.subjectCompo}`
        });
    },
    /**
     *
     * @param obj_resource
     * @return {AxiosPromise<any>}
     */
    saveResourceToMyDownload(obj_resource)
    {
        return axios.post('/api/my_download/save', {
                "resource_list": obj_resource,
                "return_list": true,
                "website": `${ window.urlData.subjectCompo}`
            }
        );
    },
    /**
     * get News Table
     * @return {AxiosPromise<any>}
     */
    getHkepNews()
    {
        return axios.get(`/api/news/get_news?subject=${ window.urlData.subjectCompo}`);
    },

    /**
     * 取得該網站的module html
     * @return {AxiosPromise<any>}
     */
    getModule()
    {
        return axios.get(`/api/module/get_all_frontend?subject=${ window.urlData.subjectCompo}`);
    },
    /**
     * frontend 搜尋api
     *
     * @param keywords string
     * @param skip int
     * @param limit int
     * @return {AxiosPromise<any>}
     */
    searchFrontend(keywords, skip, limit)
    {
        return axios.post(
            `/api/search/frontend`,
            {
                "subject": `${ window.urlData.subjectCompo}`,
                "keywords": keywords,
                "skip": skip,
                "limit": limit,
                "access_token": access_token
            }
        );
    },
    getResourcePageFrontendById(id)
    {
        return axios.post('/api/resource_page/get_frontend_by_id', {
                "id": id,
                "website": `${ window.urlData.subjectCompo}`
            }
        );
    },
    userLogin(username, password, captcha, key)
    {
        return axios.post('/api/user/login', {
            'username' : username,
            'password': password,
            'captcha': captcha,
            'key': key
        });
    },
    fetchCaptcha() {
        return axios.get('/captcha/api/flat');
    },
    /**
     *
     */
    userLogout()
    {
        return axios.get("/api/user/logout");
    },
    /**
     *
     */
    getContactUsById()
    {
        return axios.post('/api/contact_us/get_by_id', {
            "id": `${ window.urlData.subjectCompo}`
        });
    },
    checkLoginStatus(uri = "")
    {
        return axios.post(
            "/api/user/check_login_status", {
                "request_uri": uri
            }
        );
    },
    checkDownloadStatus(id)
    {
        return axios.get(`/api/check_download/${id}`);
    },
    getMpmsSystemMsg(url)
    {
        return axios.post(
            url,
            qs.stringify({
                "access_token": access_token,
                "client_id": client_id
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    },
    getWebsitePopup()
    {
        return axios.post('/api/popup/get_frontend_by_website_id',
            {
                "id": `${ window.urlData.subjectCompo}`
            }
        );
    },
    getSubcateListByMaincate(maincateId) {
        if(!maincateId || maincateId === "") {
            return
        }
        return axios.get(`/api/special_main_category/get_sub_cate_by_maincate/?maincate=${maincateId}`)
    },
    getPhotoGalleryById(subcateId, type = null, start = 0, search_key = '')
    {
        return axios.post('/api/photo_gallery/frontend_get_by_id', {
            sub_cate_id: subcateId,
            // sub_cate_id: 'prichi2_sCat_g19', // TODO hardcode sub cate id
            type: type,
            start: start,
            search_key: search_key
        });
    },
    getPhotoGalleryFilterById(subcateId)
    {
        return axios.post('/api/photo_gallery/frontend_filter_get_by_id', {
            sub_cate_id: subcateId
            // sub_cate_id: 'prichi2_sCat_g19' // TODO hardcode sub cate id
        });
    },
    getToolsByWebsite()
    {
        return axios.post('/api/tool/get_by_website_id', {
            "website_id": `${ window.urlData.subjectCompo}`,
        });
    },
    getRelatedWebsites() {
        return axios.post('/api/related_website/get_frontend_by_website_id', {
            "website_id": `${ window.urlData.subjectCompo}`,
        });
    },
    getSpecialNewsByWebsite() {
        return axios.post("/api/special_news/get_by_website_id", {'website_id': window.urlData.subjectCompo})
    },
    getLatestResource(resource_id) {
        return axios.post('/api/special_subcate/get_latest_resource', {'resource_id': resource_id})
    },
    getRelatedPrihumWebsite() {
        return axios.post('/api/related_secchi_website_url/get_by_website_id_frontend', {
            "website_id": `${ window.urlData.subjectCompo}`,
        })
    },
    getAdsBanner()
    {
        return axios.get(`/api/home/get_ads_banner?subject=${ window.urlData.subjectCompo}`);
    },
    syncToGoodNotes(resources = [])
    {
        const resource_ids = resources.map(item => `NSW-${item}`).join(',');

        // return axios.post('/api/goodnotes/import?access_token=' + access_token, {'resources_ids': resource_ids})
        return '/api/goodnotes/import?access_token=' + access_token + '&resources_ids=' + resource_ids;
    },
    getConsents(domain) {
        const path = 'consents';
        const url = new URL(path, domain).toString();
        return axios.get(url, {
            params: {
                access_token: window.access_token
            }
        });
    },
    saveConsent(domain) {
        const path = 'consent';
        const url = new URL(path, domain).toString();
        return axios.post(
            url,
            qs.stringify({
                "access_token": window.access_token
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/special_websites/prihum/api.js